<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1HS0WP/tc-custom/9781467431750.jpg?1742010960576" alt="This image is the cover for the book Arius"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arius
      </h1>
      <p class="bookDescription body article font2">
        <i>Arius</i> is widely considered to be Rowan Williams's magnum opus. Long out of print and never before available in paperback, it has been newly revised. This expanded and updated edition marks a major publishing event.<br/><br/> Arianism has been called the "archetypal Christian heresy" because it denies the divinity of Christ. In his masterly examination of Arianism, Rowan Williams argues that Arius himself was actually a dedicated theological conservative whose concern was to defend the free and personal character of the Christian God. His "heresy" grew out of an attempt to unite traditional biblical language with radical philosophical ideas and techniques and was, from the start, involved with issues of authority in the church. Thus, the crisis of the early fourth century was not only about the doctrine of God but also about the relations between emperors, bishops, and "charismatic" teachers in the church's decision-making. In the course of his discussion, Williams raises the vital wider questions of how heresy is defined and how certain kinds of traditionalism transform themselves into heresy.<br/><br/> Augmented with a new appendix in which Williams interacts with significant scholarship since 1987, this book provides fascinating reading for anyone interested in church history and the development of Christian doctrine.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rowan Williams
      </h2>
      
      <p class="authorDescription body article">Rowan Williams served as the 104th Archbishop of Canterbury from 2002 to 2012 and is now Master of Magdalene College, University of Cambridge. A Fellow of the British Academy and an internationally recognized theologian, he was previously Lady Margaret Professor of Divinity at the University of Oxford, Bishop of Monmouth, and Archbishop of Wales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbc9c7d4